// Mixpanel configuration
export const MIXPANEL_CONFIG = {
  token: '071c45e67c99ad7ac153831ae1411272',
  
  // Configuration options
  options: {
    debug: typeof window !== 'undefined' && window.location.hostname === 'localhost',
    track_pageview: true,
    persistence: 'localStorage',
    api_host: 'https://api.mixpanel.com',
    loaded: function(mixpanel) {
      console.log('🎯 [MIXPANEL] Loaded successfully');
    }
  },

  // Event names - centralized for consistency
  events: {
    // App lifecycle
    APP_INSTALLED: 'App Installed',
    APP_UNINSTALLED: 'App Uninstalled',
    
    // Plan events
    PLAN_UPGRADED: 'Plan Upgraded',
    PLAN_DOWNGRADED: 'Plan Downgraded', 
    PLAN_CANCELLED: 'Plan Cancelled',
    PLAN_VIEWED: 'Plan Page Viewed',
    
    // Feature usage
    DYNAMIC_BLOCK_CREATED: 'Dynamic Block Created',
    DYNAMIC_BLOCK_UPDATED: 'Dynamic Block Updated',
    DYNAMIC_BLOCK_DELETED: 'Dynamic Block Deleted',
    DYNAMIC_BLOCK_TOGGLED: 'Dynamic Block Toggled',
    
    // Page views
    PAGE_VIEWED: 'Page Viewed',
    DASHBOARD_VIEWED: 'Dashboard Viewed',
    SETTINGS_VIEWED: 'Settings Viewed',
    
    // User actions
    CONDITION_VALIDATED: 'Condition Validated',
    PRODUCT_SEARCHED: 'Product Searched',
    SETUP_GUIDE_COMPLETED: 'Setup Guide Completed',
    
    // Errors
    ERROR_OCCURRED: 'Error Occurred'
  },

  // User properties
  userProperties: {
    SHOP_NAME: 'Shop Name',
    SHOP_DOMAIN: 'Shop Domain',
    CURRENT_PLAN: 'Current Plan',
    INSTALL_DATE: 'Install Date',
    TOTAL_DYNAMIC_BLOCKS: 'Total Dynamic Blocks',
    CONDITIONS_USED: 'Conditions Used',
    MAX_CONDITIONS: 'Max Conditions'
  }
};
